import React, { useEffect, useState } from "react";
import NotFound from "../../../components/not-found/NotFound";
import { IconButton } from "@mui/material";
import ModalBox from "../../../components/modal/ModalBox";
import { useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import WcIcon from "@mui/icons-material/Wc";
import { deleteMemberAPi, getMemberListApi } from "../../../services/community";
import { catchMessage, elseMessage } from "../../../comman/Message";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { AvatarImg } from "../../../comman/avatar/Avatar";
import ImageModal from "../../../comman/avatar/ImageModal";
import { ViewIcon } from "../../../comman/action/ViewIcon";
import { PaginationShow } from "../../../comman/action/Pagination";

const Members = ({
  id,
  membersList,
  total,
  page,
  getMemberList,
  handlePageChange,
}) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [memberName, setMemberName] = useState("");

  const [showImgModal, setShowImgModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const findNeptune = membersList.some((data) => data?.name === "Neptune");
  // console.log('findNeptune', findNeptune)
  // ----------open-image-in-modal-full-page------------
  const openImage = (image) => {
    setShowImgModal(image ? true : false);
    setImageUrl(image);
  };
  // //*********delete product********* */
  const deleteHandler = (id, name) => {
    setDeleteModal(true);
    setDeleteId(id);
    setMemberName(name);
  };

  //--------------delete-member------------------------
  const deleteMember = async () => {
    try {
      let data = {
        communityId: id,
        userId: deleteId,
      };
      const res = await deleteMemberAPi(data);
      if (res?.data?.status === 200) {
        toast.success(res.data.message);
        setDeleteModal(false);
        getMemberList();
      } else {
        elseMessage(res);
      }
    } catch (e) {
      catchMessage(e);
    }
  };
  useEffect(() => {
    getMemberList();
  }, [page]);
  return (
    <>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Profile</th>
              <th>Members Name </th>
              <th>User ID</th>
              <th className="text-center"> Action </th>
            </tr>
          </thead>

          <tbody>
            {membersList.length > 0 ? (
              membersList.map(
                ({ name, username, _id, profile, role }, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{++index + (page - 1) * 10}</td>
                        <td>
                          <AvatarImg
                            id={_id}
                            image={profile}
                            openImage={openImage}
                          />
                        </td>
                        <td>
                          {name || "N/A"}
                          {role === "admin" ? (
                            <span className="role_admin">{role}</span>
                          ) : role === "moderator" ? (
                            <span className="role_moderator">{role}</span>
                          ) : null}
                        </td>
                        <td>{username || "N/A"}</td>
                        <td>
                          {name !== "Neptune" && (
                            <div className="d-flex justify-content-center">
                              <ViewIcon
                                to={`/user-management/view-details/${_id}`}
                              />

                              <IconButton
                                onClick={() => deleteHandler(_id, name)}
                              >
                                <DeleteForeverIcon
                                  sx={{ color: "red", fontSize: 26 }}
                                />
                              </IconButton>
                            </div>
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )
            ) : (
              <NotFound
                cols={10}
                msg="No members Found!"
                icon={<WcIcon style={{ fontSize: 48 }} />}
                // loader={loader}
              />
            )}
          </tbody>
        </table>
        <PaginationShow
          total={total}
          activePage={page}
          handlePageChange={handlePageChange}
        />
      </div>
      {/* <PaginationShow
                total={total}
                activePage={page}
                handlePageChange={handlePageChange}
            /> */}
      {/* --------delete-product-modal---------- */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title="Remove Member"
        description={
          <span>
            Do you want to remove <strong>{memberName}</strong>?
          </span>
        }
        action={deleteMember}
      />
      {/* --------show-img-in-modal-from-api---------- */}
      <ImageModal
        showModal={showImgModal}
        closeModal={setShowImgModal}
        imageUrl={imageUrl}
        title="User Image"
      />
    </>
  );
};

export default Members;
